<template>
  <b-container>
    <v-sheet>
      <v-calendar ref="calendar" :event-color="getEventColor" :events="events" :start="startDate"
        :weekday-format="myDayFormat" :weekdays="weekView" color="primary" type="week">
        <template v-slot:day-label-header="{}">
          <div></div>
        </template>
        <template v-slot:event="{ event }">
          <div class="fill-height cursor-point" layout="column" @click.stop="openModalInfoHour(event)">
            {{
              event.start.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
            -
            {{
              event.end.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </div>
        </template>
      </v-calendar>
    </v-sheet>

    <b-modal id="modal-schedule-ipros" cancel-title="Cerrar" centered ok-title="Cambiar" @ok="saveFormStep2">
      <template #modal-title>{{
        $t(
          "public.components.workschedule.WorkscheduleIpros.modalSchedule.changeDuration"
        )
      }}
      </template>
      <form action="#">
        <b-form-group label-for="duration">
          <template slot="label">{{
            $t(
              "public.components.workschedule.WorkscheduleIpros.modalSchedule.duration"
            )
          }}: *
          </template>
          <b-form-input v-model="duration" :disabled="disabled" type="number" v-bind:class="{
            'text-danger': isFormDurationErrors,
            'is-invalid': isFormDurationErrors,
          }" @blur="checkDuration(duration)"></b-form-input>
          <ul v-if="isFormDurationErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('duration')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </form>
    </b-modal>
    <b-modal id="modal-info-schedule-ipros" cancel-title="Cerrar" centered hide-footer size="lg">
      <template #modal-title>{{
        $t(
          "public.components.workschedule.WorkscheduleIpros.modalSchedule.info"
        )
      }}
      </template>
      <b-form-group label-for="dayScheduleInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleIpros.modalSchedule.day"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="dayScheduleInfo" class="list-group-item">
            {{ dayScheduleInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="timeStartScheduleInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleIpros.modalSchedule.initialHour"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="timeStartScheduleInfo" class="list-group-item">
            {{ timeStartScheduleInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="timeEndScheduleInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleIpros.modalSchedule.endHour"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="timeEndScheduleInfo" class="list-group-item">
            {{ timeEndScheduleInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="visitTypesInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleIpros.modalSchedule.visitType"
          )
        }}:
        </template>
        <ul v-if="visitTypesInfo" class="list-group">
          <li v-for="(item, index) in visitTypesInfo" :key="index" class="list-group-item">
            <i :style="'color: ' + item.colour" class="fas fa-circle mr-2"></i>
            {{ item.name }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";
//JSON Mock
import DaySelect from "../../json/Day";

import validator from "vue-m-validator";
import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import professionalService from "../../services/professional";
import utilsService from "../../services/utils";

export default {
  name: "WorkscheduleIpros",
  props: ["updateDataComponets", "idProfessional"],
  mounted() {
    xray.index();
    this.getWorkschedule();
  },
  components: {
    validator,
  },
  computed: {
    //FormSchedule
    isFormDurationErrors() {
      let errors = this.validatorStep1.getErrors("duration");
      return errors && errors.length > 0;
    },
  },
  methods: {
    openModalInfoHour(item) {
      this.timeStartScheduleInfo = utilsService.adjustDateTime(moment(item.start).format("DD/MM/YYYY HH:mm"), "HH:mm");
      this.timeEndScheduleInfo = utilsService.adjustDateTime(moment(item.end).format("DD/MM/YYYY HH:mm"), "HH:mm");
      this.dayScheduleInfo = this.myDayFormatInfo(item.idDay);
      this.visitTypesInfo = item.visitTypes;

      this.$bvModal.show("modal-info-schedule-ipros");
    },
    myDayFormatInfo(day) {
      if (day === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }
      if (day === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }
      if (day === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }
      if (day === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }
      if (day === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }
      if (day === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }
      if (day === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
      return "";
    },
    myDayFormat(day) {
      if (day.weekday === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }
      if (day.weekday === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }
      if (day.weekday === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }
      if (day.weekday === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }
      if (day.weekday === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }
      if (day.weekday === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }
      if (day.weekday === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkDuration(_duration) {
      const DURATION = _duration.trim();
      const RULE_1 = {
        expression: !DURATION || DURATION === "",
        name: "duration",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleIpros.errors.erDuration"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    clearFormSchedule() {
      //this.duration = 45;
    },
    openModalSchedule(option, id) {
      this.optionModalSchedule = option;
      this.disabledSchedule = false;
      this.clearFormSchedule();
      this.validatorStep1.errors = [];
      this.$bvModal.show("modal-schedule-ipros");
    },
    saveSchedule() {
      if (this.optionModalSchedule === "create") {
        this.updateDuration();
      }
    },
    updateDuration() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.updateDurationWorkscheduleIpros(
          self.idProfessional,
          self.workscheduleIprosId,
          this.duration
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.getAllSchedules();
            self.$bvModal.hide("modal-schedule-ipros");
            self.updateDataComponets();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.updateDurationWorkscheduleIpros",
            module: "component-account-workscheduleGlobal",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: self.idProfessional,
              workscheduleIprosId: self.workscheduleIprosId,
              duration: this.duration
            }),
          });
        },
        " "
      );
    },
    async getWorkschedule() {
      let self = this;

      professionalService
        .getWorkscheduleIpros(self.idProfessional)
        .then((response) => {
          if (response) {
            self.duration = response.data.duration;
            self.workscheduleIprosId = response.data.id;
            this.getAllSchedules();
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getWorkscheduleIpros",
            module: "component-account-workscheduleGlobal",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: this.idProfessional
            }),
          });
        });
    },
    getAllSchedules() {
      let self = this;

      professionalService
        .getAllSchedulesWorkscheduleIpros(
          self.idProfessional,
          self.workscheduleIprosId
        )
        .then((response) => {
          if (response) {
            self.events = [];
            response.data.forEach(function (item) {
              const event = {
                id: item.id,
                idWorkschedule: item.idWorkschedule,
                idDay: item.idDay,
                title: item.title,
                name: item.title,
                start: new Date(item.start),
                end: new Date(item.end),
                visitTypes: item.visitTypes,
                color: item.color,
                timed: item.timed,
              };
              self.startDate = new Date(item.start);
              self.events.push(event);
            });
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllSchedulesWorkscheduleIpros",
            module: "component-account-workscheduleGlobal",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: self.idProfessional, workscheduleIprosId: self.workscheduleIprosId
            }),
          });
        });
    },
    checkFormStep2() {
      this.checkDuration(this.duration);
    },
    saveFormStep2(evt) {
      evt.preventDefault();
      this.checkFormStep2();
      if (this.validatorStep1.errors.length === 0) {
        this.saveSchedule();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.notification.error"
          ),
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.notification.descErrorStep2"
          ),
          type: "error",
        });
      }
    },
    //Schedule
    getEventColor(event) {
      return event.color;
    },
  },
  data() {
    return {
      startDate: new Date(),
      // Form hour info
      timeStartScheduleInfo: "",
      timeEndScheduleInfo: "",
      dayScheduleInfo: "",
      visitTypesInfo: [],

      //Form schedule
      duration: 45,
      workscheduleIprosId: "",

      daysSelect: DaySelect,
      weekView: [1, 2, 3, 4, 5, 6, 0],
      optionModal: "",
      disabled: false,
      isFirstRun: true,
      isValidateStep1: false,
      showSeason: true,
      validatorStep1: validator,
      visitTypeSelect: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.notification.initialDate"
          ),
          value: "dateStart",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.notification.dateEnd"
          ),
          value: "dateEnd",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.notification.allYear"
          ),
          value: "allYear",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleIpros.notification.actions"
          ),
          value: "actions",
        },
      ],
      seasons: [],
      events: [],
    };
  },
  components: {
    Multiselect,
  },
};
</script>